export function dataInRequest(params = {}) {
  return {
    type: '@estoqueAreia/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@estoqueAreia/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@estoqueAreia/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@estoqueAreia/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@estoqueAreia/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@estoqueAreia/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@estoqueAreia/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@estoqueAreia/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@estoqueAreia/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@estoqueAreia/RECORD_FILTERING',
    payload: { params },
  };
}
